import React from "react";
import EntranceExaminationPage from "./EntranceExaminationPage";

const EntranceMathematics = () => {
    return (
        <EntranceExaminationPage
            subject="mathematics"
        />
    );
};

export default EntranceMathematics;